/** Local storage keys for the session (shared by the auth screens and the workspace root). */
export const TOKEN_KEY = 'lumen.token';
export const SESSION_KEY = 'lumen.session';
export const LAST_WS_KEY = 'lumen.lastWorkspace';
/** The page last opened on this device in a workspace (written at once, so a reload right after still finds it). */
export const lastPageKey = (wsId: string) => `lumen.lastPage.${wsId}`;
